
import Loader from '~/components/loaders/lole-loader'
import Gallery5 from '~/components/product-page/pdp-gallery/gallery-5'
import Gallery6 from '~/components/product-page/pdp-gallery/gallery-6'
import Gallery7 from '~/components/product-page/pdp-gallery/gallery-7'
import Gallery8 from '~/components/product-page/pdp-gallery/gallery-8'
import Gallery9 from '~/components/product-page/pdp-gallery/gallery-9'
import Gallery10 from '~/components/product-page/pdp-gallery/gallery-10'
import GalleryDefault from '~/components/product-page/pdp-gallery/gallery-default'
import GalleryMobile from '~/components/product-page/pdp-gallery/gallery-mobile'
import GalleryZoom from '~/components/product-page/pdp-gallery/gallery-zoom.vue'

export default {
  components: {
    Loader,
    Gallery5,
    Gallery6,
    Gallery7,
    Gallery8,
    Gallery9,
    Gallery10,
    GalleryDefault,
    GalleryMobile,
    GalleryZoom,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showLoader: false,
      showZoom: false,
    }
  },
  computed: {
    medias() {
      return this.product.medias
    },
  },
  watch: {
    medias() {
      this.showLoader = true
      setTimeout(() => {
        this.showLoader = false
      }, 450)
    },
  },
  methods: {
    openZoom(index) {
      this.showZoom = index + 1
      document.body.style.overflow = 'hidden'
    },
    closeZoom() {
      this.showZoom = false
      document.body.style.overflow = ''
    },
    removeVideoOnError(index) {
      this.medias.splice(index, 1)
    },
    // TODO: Detect loading of Gallery images and display loader
  },
}
